<template>
  <div class="shl-result">
    <div class="title">{{ $tr('interview.landing.modules.shl.reports') }}</div>

    <div v-for="(report, index) in data.reports" :key="index" class="response-item">
      <div class="report-title">{{ report.title }}</div>
      <!-- <div class="item">{{ `${$tr('responses.tabs.test.feniche.instrumets')} ${report.instruments}` }}</div> -->
      <!-- <div class="item">{{ `${$tr('responses.tabs.test.feniche.norm_group')} ${report.norm_group}` }}</div> -->
      <template v-if="report.report.EXTRA || report.report.STEN">
        <template v-if="report.instruments === 'NMG4'">
          <div class="sub-title">{{ $tr('admin_console.response.tests.resultScore') }}</div>
          <div class="item">
            {{ $tr('responses.tabs.test.feniche.total_questions') }}
            {{ report.report.EXTRA.NMG4.total_questions }}
          </div>
          <div class="item">
            {{ $tr('responses.tabs.test.feniche.answered_questions') }}
            {{ report.report.EXTRA.NMG4.answered_questions }}
          </div>
          <div class="item">
            {{ $tr('responses.tabs.test.feniche.invalid_answers') }}
            {{ report.report.EXTRA.NMG4.invalid_answers }}
          </div>
          <div class="item">
            {{ $tr('responses.tabs.test.feniche.valid_answers') }}
            {{ report.report.EXTRA.NMG4.valid_answers }}
          </div>
          <div class="item">
            {{ $tr('responses.tabs.test.feniche.grade') }}
            {{ $tr('responses.tabs.test.feniche.grade_' + report.report.GRADE.NMG4) }}
          </div>
          <div class="item">
            {{ $tr('responses.tabs.test.feniche.percentile') }} {{ report.report.PCTL.NMG4 }}
          </div>
          <div class="item">{{ `T: ${report.report.T.NMG4}` }}</div>
        </template>

        <template v-if="report.instruments === 'OPQ32iRUS'">
          <div class="sub-title">{{ $tr('admin_console.response.tests.resultScore') }}</div>
          <div class="sub-title-2">{{ $tr('responses.tabs.test.peopleManage') }}</div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.persuasive') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP1 })
            }}
            <div class="info-icon" @click="info_modal = 'RP1'">i</div>
          </div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.сontrolling') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP2 })
            }}
            <div class="info-icon" @click="info_modal = 'RP2'">i</div>
          </div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.outspoken') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP3 })
            }}
            <div class="info-icon" @click="info_modal = 'RP3'">i</div>
          </div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.independentMinded') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP4 })
            }}
            <div class="info-icon" @click="info_modal = 'RP4'">i</div>
          </div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.outgoing') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP5 })
            }}
            <div class="info-icon" @click="info_modal = 'RP5'">i</div>
          </div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.affiliative') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP6 })
            }}
            <div class="info-icon" @click="info_modal = 'RP6'">i</div>
          </div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.sociallyConfident') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP7 })
            }}
            <div class="info-icon" @click="info_modal = 'RP7'">i</div>
          </div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.modest') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP8 })
            }}
            <div class="info-icon" @click="info_modal = 'RP8'">i</div>
          </div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.democratic') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP9 })
            }}
            <div class="info-icon" @click="info_modal = 'RP9'">i</div>
          </div>
          <div class="item">
            {{
              $tr('responses.tabs.test.feniche.caring') +
              ': ' +
              $tr('responses.tabs.test.feniche.points', { n: report.report.STEN.RP10 })
            }}
            <div class="info-icon" @click="info_modal = 'RP10'">i</div>
          </div>
          <br />
          <div class="sub-title-2">{{ $tr('responses.tabs.test.tasksManage') }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.dataRational')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS1})}` }} <div @click="info_modal = 'TS1'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.evaluative')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS2})}` }} <div @click="info_modal = 'TS2'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.behavioural')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS3})}` }} <div @click="info_modal = 'TS3'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.conventional')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS4})}` }} <div @click="info_modal = 'TS4'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.conceptual')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS5})}` }} <div @click="info_modal = 'TS5'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.innovative')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS6})}` }} <div @click="info_modal = 'TS6'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.varietySeeking')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS7})}` }} <div @click="info_modal = 'TS7'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.adaptable')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS8})}` }} <div @click="info_modal = 'TS8'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.forwardThinking')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS9})}` }} <div @click="info_modal = 'TS9'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.detailConscious')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS10})}` }} <div @click="info_modal = 'TS10'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.conscientious')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS11})}` }} <div @click="info_modal = 'TS11'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.ruleFollowing')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.TS12})}` }} <div @click="info_modal = 'TS12'" class="info-icon">i</div></div>
          <br>
          <div class="sub-title-2">{{ $tr('responses.tabs.test.selfManage') }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.relaxed')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE1})}` }} <div @click="info_modal = 'FE1'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.worrying')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE2})}` }} <div @click="info_modal = 'FE2'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.toughMinded')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE3})}` }} <div @click="info_modal = 'FE3'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.optimistic')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE4})}` }} <div @click="info_modal = 'FE4'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.trusting')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE5})}` }} <div @click="info_modal = 'FE5'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.emotionallyControlled')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE6})}` }} <div @click="info_modal = 'FE6'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.vigorous')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE7})}` }} <div @click="info_modal = 'FE7'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.competitive')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE8})}` }} <div @click="info_modal = 'FE8'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.achieving')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE9})}` }} <div @click="info_modal = 'FE9'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.decisive')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.FE10})}` }} <div @click="info_modal = 'FE10'" class="info-icon">i</div></div>
          <!-- <div class="item">{{ `${$tr('responses.tabs.test.feniche.decisive')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CNS})}` }} <div @click="info_modal = 'CNS'" class="info-icon">i</div></div> -->
          <br/>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.consistency')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CNS})}` }} <div @click="info_modal = 'CNS'" class="info-icon">i</div></div>
          <br/>
        </template>
        <template v-if="report.instruments === 'CCSQ73RUS'">
          <div class="sub-title">{{ $tr('admin_console.response.tests.resultScore') }}</div>
          <div class="sub-title-2">{{ $tr('responses.tabs.test.feniche.relations') }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.persuasive')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CR1})}` }} <div @click="info_modal = 'CR1'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.self-control')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CR2})}` }} <div @click="info_modal = 'CR2'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.empathic')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CR3})}` }} <div @click="info_modal = 'CR3'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.modest')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CR4})}` }} <div @click="info_modal = 'CR4'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.participative')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CR5})}` }} <div @click="info_modal = 'CR5'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.sociable')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CR6})}` }} <div @click="info_modal = 'CR6'" class="info-icon">i</div></div>
          <div class="sub-title-2">{{ $tr('responses.tabs.test.feniche.thinking_style') }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.analytical')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CT1})}` }} <div @click="info_modal = 'CT1'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.innovative')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CT2})}` }} <div @click="info_modal = 'CT2'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.flexible')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CT3})}` }} <div @click="info_modal = 'CT3'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.structured')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CT4})}` }} <div @click="info_modal = 'CT4'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.detail_conscious')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CT5})}` }} <div @click="info_modal = 'CT5'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.conscientious')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CT6})}` }} <div @click="info_modal = 'CT6'" class="info-icon">i</div></div>
          <div class="sub-title-2">{{ $tr('responses.tabs.test.feniche.emotions') }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.resilience')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CE1})}` }} <div @click="info_modal = 'CE1'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.competitive')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CE2})}` }} <div @click="info_modal = 'CE2'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.results_orientated')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CE3})}` }} <div @click="info_modal = 'CE3'" class="info-icon">i</div></div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.energetic')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CE4})}` }} <div @click="info_modal = 'CE4'" class="info-icon">i</div></div>
          <br/>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.consistencyScale')}: ${$tr('responses.tabs.test.feniche.points', {n: report.report.STEN.CNS})}` }} <div @click="info_modal = 'CNS'" class="info-icon">i</div></div>
          <br/>
        </template>
        <template v-if="report.instruments === 'VD2RUS' || report.instruments === 'VD2'">
          <div class="sub-title">{{ $tr('admin_console.response.tests.resultScore') }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.total_questions')} ${report.report.EXTRA.VD2.total_questions}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.answered_questions')} ${report.report.EXTRA.VD2.answered_questions}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.invalid_answers')} ${report.report.EXTRA.VD2.invalid_answers}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.valid_answers')} ${report.report.EXTRA.VD2.valid_answers}` }}</div>
          <div class="item" v-if="report.report.GRADE.VD2">{{ `${$tr('responses.tabs.test.feniche.grade')} ${$tr('responses.tabs.test.feniche.grade_' + report.report.GRADE.VD2)}` }}</div>
          <div class="item" v-if="report.report.PCTL.VD2">{{ `${$tr('responses.tabs.test.feniche.percentile')} ${report.report.PCTL.VD2}` }}</div>
          <div class="item" v-if="report.report.T.VD2">{{ `T: ${report.report.T.VD2}` }}</div>
        </template>
        <template v-if="report.instruments === 'ND2RUS'">
          <div class="sub-title">{{ $tr('admin_console.response.tests.resultScore') }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.total_questions')} ${report.report.EXTRA.ND2.total_questions}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.answered_questions')} ${report.report.EXTRA.ND2.answered_questions}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.invalid_answers')} ${report.report.EXTRA.ND2.invalid_answers}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.valid_answers')} ${report.report.EXTRA.ND2.valid_answers}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.grade')} ${$tr('responses.tabs.test.feniche.grade_' + report.report.GRADE.ND2)}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.percentile')} ${report.report.PCTL.ND2}` }}</div>
          <div class="item">{{ `T: ${report.report.T.ND2}` }}</div>
        </template>
        <template v-if="report.instruments === 'ELT'">
          <div class="sub-title">{{ $tr('admin_console.response.tests.resultScore') }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.total_questions')} ${report.report.EXTRA.ELT.total_questions}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.answered_questions')} ${report.report.EXTRA.ELT.answered_questions}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.invalid_answers')} ${report.report.EXTRA.ELT.invalid_answers}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.valid_answers')} ${report.report.EXTRA.ELT.valid_answers}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.grade')} ${$tr('responses.tabs.test.feniche.' + get_elt_grade(+report.report.EXTRA.ELT.valid_answers))}` }}</div>
          <div class="item">{{ `${$tr('responses.tabs.test.feniche.percentile')} ${report.report.PCTL.ELT}` }}</div>
          <div class="item">{{ `T: ${report.report.T.ELT}` }}</div>
        </template>
      </template>
      <div v-if="report.instruments !== 'CCSQ73RUS'" class="special-border"></div>
    </div>
    <div class="title">{{ $tr('interview.landing.modules.shl.title') }}</div>
    <div v-for="test in data.tests" :key="test.uuid" class="response-item">
      <div class="sub-title">{{ test.title }}:</div>
      <div class="item">{{ `${$tr('responses.tabs.test.talentq.status')} ${test.state}` }}</div>
      <div v-if="test.started_at" class="item">
        {{ $tr('responses.tabs.test.feniche.started_at') }}
        {{ moment(test.started_at).format('YYYY-MM-DD HH:mm') }}
      </div>
      <div v-if="test.finished_at" class="item">
        {{ $tr('responses.tabs.test.feniche.finished_at') }}
        {{ moment(test.finished_at).format('YYYY-MM-DD HH:mm') }}
      </div>
    </div>
    <vmodal v-if="info_modal" :width="580" :dialog="true" @close="info_modal = null">
      <div slot="title">{{ info_content[info_modal].title }}</div>
      <div slot="body">
        <div class="feniche-modal-content" v-html="info_content[info_modal].body"></div>
        <div class="button-wrapper">
          <vbutton label="common.ok" @click="info_modal = null" />
        </div>
      </div>
    </vmodal>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'FenicheResponseShlResult',

    props: {
      data: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        info_modal: null
      };
    },

    computed: {
      info_content() {
        const keys = {
          CR1: 'persuasive',
          CR2: 'self-control',
          CR3: 'empathic',
          CR4: 'modest',
          CR5: 'participative',
          CR6: 'sociable',
          CT1: 'analytical',
          CT2: 'innovative',
          CT3: 'flexible',
          CT4: 'structured',
          CT5: 'detail_conscious',
          CT6: 'conscientious',
          CE1: 'resilience',
          CE2: 'competitive',
          CE3: 'results_orientated',
          CE4: 'energetic',
          CCO: 'consistency',
          RP1: 'persuasive',
          RP2: 'сontrolling',
          RP3: 'outspoken',
          RP4: 'independentMinded',
          RP5: 'outgoing',
          RP6: 'affiliative',
          RP7: 'sociallyConfident',
          RP8: 'modest',
          RP9: 'democratic',
          RP10: 'caring',
          TS1: 'dataRational',
          TS2: 'evaluative',
          TS3: 'behavioural',
          TS4: 'conventional',
          TS5: 'conceptual',
          TS6: 'innovative',
          TS7: 'varietySeeking',
          TS8: 'adaptable',
          TS9: 'forwardThinking',
          TS10: 'detailConscious',
          TS11: 'conscientious',
          TS12: 'ruleFollowing',
          FE1: 'relaxed',
          FE2: 'worrying',
          FE3: 'toughMinded',
          FE4: 'optimistic',
          FE5: 'trusting',
          FE6: 'emotionallyControlled',
          FE7: 'vigorous',
          FE8: 'competitive',
          FE9: 'achieving',
          FE10: 'decisive',
          CNS: 'consistencyScale'
        };
        return Object.keys(keys).reduce((info_content, key) => {
          info_content[key] = {
            title: this.$tr(`responses.tabs.test.feniche.${keys[key]}`),
            body: this.$tr('responses.tabs.test.feniche.min_max', {
              min: this.$tr(`responses.tabs.test.feniche.${keys[key]}_min`),
              max: this.$tr(`responses.tabs.test.feniche.${keys[key]}_max`)
            })
          };
          return info_content;
        }, {});
      }
    },

    methods: {
      moment,
      get_elt_grade(valid_answers) {
        if (valid_answers < 4) {
          return 'beginner';
        } else if (valid_answers < 13) {
          return 'elementary';
        } else if (valid_answers < 21) {
          return 'pre-intermediate';
        } else if (valid_answers < 31) {
          return 'intermediate';
        } else if (valid_answers < 46) {
          return 'upper-intermediate';
        } else {
          return 'advanced';
        }
      }
    }
  };
</script>

<style lang="scss">
  .feniche-modal-content {
    span {
      font-weight: bold;
    }
  }
</style>
<style scoped lang="scss">
  .special-border {
    width: 100%;
    height: 2px;
    border-bottom: 2px solid black;
  }
  .report-title {
    font-size: 18px;
    text-align: left;
    font-weight: bold;
  }
  .shl-result {
    padding: 5px 0;
    border-bottom: 1px solid #d7d7d7;
    .title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      margin: 15px 0;
    }
    .response-item {
      margin: 15px 0;
      .sub-title {
        font-size: 16px;
        font-weight: bold;
        margin: 10px 0;
      }
      .sub-title-2 {
        font-size: 15px;
        font-weight: bold;
        margin: 7px 0;
      }
      .item {
        font-size: 15px;
        margin: 5px 0;
        .info-icon {
          display: inline-block;
          border-radius: 50%;
          width: 18px;
          color: white;
          background: gray;
          text-align: center;
          cursor: pointer;
          opacity: 0.7;
          transition: opacity 0.2s;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
    .button-wrapper {
      margin: 10px;
      text-align: center;
    }
  }
</style>
